import React from 'react';
import { DrawerBody, DrawerFooter } from '@fiverr-private/overlay';
import { Button } from '@fiverr-private/button';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Form, FormControl, FormElement, Radio, RadioGroup } from '@fiverr-private/forms';
import { Heading, Text } from '@fiverr-private/typography';
import { useBriefCreationContext } from '../../context/BriefCreationContext';
import { useBriefForm } from '../../hooks';
import { getLeafId } from '../../utils';
import { AppI18n } from '../../i18n';
import { Step } from '../../constants';
import { description, radioParent } from './styles.ve.css';

export const DisambiguationStep = () => {
  const [disabled, setDisabled] = React.useState(true);
  const { methods, onSubmit, isLoading } = useBriefForm();
  const { briefClassification, setStep, regenerateContextId } = useBriefCreationContext();

  const leafClassifications = briefClassification?.leaf_classification || [];

  const onSkip = () => {
    methods.setValue('leaf_category_id', getLeafId(leafClassifications[0]));

    onSubmit();
  };

  const goBack = () => {
    setStep(Step.Creation);
    regenerateContextId();
  };

  const onChange = (v: string) => setDisabled(!v);

  return (
    <Form methods={methods} onSubmit={onSubmit} height="100%">
      <DrawerBody>
        <Heading as="h5">
          <AppI18n k="disambiguation_step.title" />
        </Heading>
        <Container paddingTop="16">
          <FormControl name="leaf_category_id">
            <FormElement>
              <RadioGroup onChange={onChange} name="leaf_category_id">
                {leafClassifications.map((classification) => (
                  <Container paddingBottom="8" key={getLeafId(classification)} display="flex" alignItems="center">
                    <Radio className={radioParent} name={classification.display_name} value={getLeafId(classification)}>
                      <Stack paddingLeft="4" direction="column" gap="1">
                        <Text fontWeight="bold">{classification.display_name}</Text>
                        <Text className={description}>{classification.explainer}</Text>
                      </Stack>
                    </Radio>
                  </Container>
                ))}
              </RadioGroup>
            </FormElement>
          </FormControl>
        </Container>
      </DrawerBody>
      <DrawerFooter>
        <Stack direction="row" gap="0">
          <Container flexGrow={1}>
            <Button type="button" variant="outline" onClick={goBack}>
              <AppI18n k="back" />
            </Button>
          </Container>
          <Button type="button" variant="ghost" onClick={onSkip}>
            <AppI18n k="skip" />
          </Button>
          <Button loading={isLoading} type="submit" disabled={disabled}>
            <AppI18n k="continue" />
          </Button>
        </Stack>
      </DrawerFooter>
    </Form>
  );
};
